import {Injectable}          from '@angular/core';
import {GlobalIsoDateString} from '@djsharkk/logr-types';
import {DateTime}            from 'luxon';
import {BehaviorSubject}     from 'rxjs';

@Injectable({
				providedIn: 'root'
			})
export class DataFilterService {
	dateMin: string = this.formatDate(new Date(2024, 1, 20));
	dateEnd: Date = DateTime.now().endOf('day').toJSDate();

	dateToday = new Date();
	dateStart: Date = DateTime.fromJSDate(new Date(new Date().setDate(new Date().getDate() - 22))).startOf('day').toJSDate();

	dateRange = new BehaviorSubject<Date[]>([]);

	constructor() {
		this.processFilters();
	}

	formatDate(date: Date): GlobalIsoDateString {
		return DateTime.fromJSDate(date).toFormat(
			'yyyy-MM-dd'
		) as GlobalIsoDateString;
	}

	processFilters(newStart?: string) {
		this.dateRange.next(
			this.generateDates(
				newStart
				? DateTime.fromFormat('yyyy-MM-dd', newStart).toJSDate()
				: this.dateStart,
				this.dateEnd
			)
		);
	}

	private generateDates(start: Date, end: Date) {
		const s = DateTime.fromJSDate(start).startOf('day');
		const e = DateTime.fromJSDate(end).endOf('day');


		const dates: Date[] = [];

		let currentDate = s;
		while (currentDate <= e) {
			dates.push(currentDate.toJSDate());
			currentDate = currentDate.plus({days: 1});
		}

		return dates;
	}
}
